<template>

    <span>
    <v-layout mb-4>
      <v-flex xs10 ml-3>
        <h2 class="lime--text lighten-1 pt-3">Gerenciar Usuários - Inclusão</h2>
      </v-flex>
      <v-flex xs2 text-right>
        <v-btn
          color="blue-grey"
          class="black--text"
          :to="{name: 'users'}"
        >
          <v-icon dark>keyboard_arrow_left</v-icon>
          Voltar
        </v-btn>
      </v-flex>
    </v-layout>
        <form-user :btnLabel="btnLabel"></form-user>
    </span>
        
</template>

<script>
import FormUserComponent from "./partial/FormUserComponent";

export default {
  name: "AddUserComponent",
  data () {
    return {
        btnLabel: 'Incluir'
    }
  },
  methods: {

  },
  components: {
    formUser: FormUserComponent,
  }
};
</script>

<style scoped>

</style>
